import { render, staticRenderFns } from "./AnalysisComponent.vue?vue&type=template&id=5b489c0b&scoped=true&"
import script from "./AnalysisComponent.vue?vue&type=script&lang=ts&"
export * from "./AnalysisComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AnalysisComponent.vue?vue&type=style&index=0&id=5b489c0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b489c0b",
  null
  
)

export default component.exports